// <!-- Longchamp Policy -->
import { fetchCart,ProductLoader } from "./theme.js?v=3";

const validateLongchamp = (cart, redirect = false) => {
  const selectedVendor = "Longchamp";
  const cartItems = cart.items;
  const longchampItems = cartItems.filter(
    (item) => item.vendor === selectedVendor
  );

  for (const item of longchampItems) {
    if (item.quantity > 3) {
      if (redirect) {
        window.location.href = "/cart";
        return;
      }
      const lineItems = document.querySelectorAll(
        `.line-item[data-variant-id="${item.id}"]>.line-item-info`
      );
      for (const lineItem of lineItems) {
        const div = document.createElement("div");
        div.className = "text-error";
        div.textContent =
          "You can only purchase three items per style per transaction. Please modify your order.";
        lineItem.append(div);
      }
      const cartForm = document.querySelector("#cart-page-main");
      if (cartForm) {
        const checkoutButton = cartForm["checkout"];
        checkoutButton.disabled = true;
        checkoutButton.classList.add("button--subdued");
        checkoutButton.classList.add("button--outline");
      }
    }
  }

  const totalQuantity = longchampItems.reduce(
    (total, item) => total + item.quantity,
    0
  );
  if (totalQuantity > 10) {
    if (redirect) {
      window.location.href = "/cart";
      return;
    }
    const lineItems = document.querySelectorAll(
      `.line-item[data-vendor="${selectedVendor}"]>.line-item-info`
    );
    for (const lineItem of lineItems) {
      const div = document.createElement("div");
      div.className = "text-error";
      div.textContent =
        "Your purchase exceeds the limit of 10 Longchamp items. Please modify your order.";
      lineItem.append(div);
    }
    const cartForm = document.querySelector("#cart-page-main");
    if (cartForm) {
      const checkoutButton = cartForm["checkout"];
      checkoutButton.disabled = true;
      checkoutButton.classList.add("button--subdued");
      checkoutButton.classList.add("button--outline");
    }
  }
};

const validateLoccitane =async (cart, redirect = false) => {
  const selectedTag = "LOccitanePrivateSaleItems"
  const selectedTag2 = "LOccitanePrivateSale2026"
  // const selectedTag2 = "Volume_200ml"

  const selectedVendor = "Occitane";
  const cartItems = cart.items;
  const loccitaneItems = cartItems.filter(
    (item) => item.vendor.includes(selectedVendor)
  );
  

  const skuMap = new Map()
  const promises = []
  const productMap = new Map()

  for (const item of loccitaneItems) {
    let skuDetails = skuMap.get(item.sku)
    if(!skuDetails){
      skuDetails = {quantity:0}
    }
    skuDetails.quantity += item.quantity
    skuMap.set(item.sku,skuDetails)
    promises.push(ProductLoader.load(item.handle))
  }
  const products= await Promise.all(promises)
  for (const product of products) {
     for (const variant of product.variants) {
        productMap.set(variant.sku,product)
     }
  }

  for (const item of loccitaneItems) {
    const skuDetails = skuMap.get(item.sku) ?? { quantity:0 }
    const product = productMap.get(item.sku) ?? { tags:[] }

    if ((product.tags.includes(selectedTag)||product.tags.includes(selectedTag2)) && skuDetails.quantity > 10 ) {
      if (redirect) {
        window.location.href = "/cart";
        return;
      }
      const lineItems = document.querySelectorAll(
        `.line-item[data-variant-id="${item.id}"]>.line-item-info`
      );
      for (const lineItem of lineItems) {
        const div = document.createElement("div");
        div.className = "text-error";
        div.textContent =
          "You can only purchase 10 pieces per product per transaction. Please modify your order.";
        lineItem.append(div);
      }
      const cartForm = document.querySelector("#cart-page-main");
      if (cartForm) {
        const checkoutButton = cartForm["checkout"];
        checkoutButton.disabled = true;
        checkoutButton.classList.add("button--subdued");
        checkoutButton.classList.add("button--outline");
      }
    }
  }

 
};

document.addEventListener("DOMContentLoaded", async function (event) {
   fetchCart
      .then((data) => {
        validateLongchamp(data);
        validateLoccitane(data)
      })
      .catch((error) => console.error("There was an error!", error));
});

document.addEventListener("cart:change", function (event) {
  setTimeout(()=>{
    validateLongchamp(event.detail.cart);
    validateLoccitane(data)
  },100)
});
